import { Panel, PanelBody, PanelGrid, PanelGridAmount, PanelGridItem } from 'components';
import { BillbackInfoData } from 'types';
import styles from './BillbackInfo.module.scss';

type Props = {
    billbackInfo: BillbackInfoData
}

export default function BillbackInfo({ billbackInfo }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                    <PanelGridAmount
                            label={"Amount: "}
                            value={billbackInfo.billbackAmount}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Billback Number: "}
                            value={billbackInfo.billbackNumber}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Invoice: "}
                            value={billbackInfo.billbackNumber}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Voucher: "}
                            value={billbackInfo.voucherId}
                        />
                    </div>
                </PanelGrid>

            </PanelBody>
        </Panel>
    )
}